
{
  "familyId": "GET-NEGATIEF-PLUS",
  "questions": [
    {
      "id": "GET-NEGATIEF-PLUS-001",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "multiple_choice",
      "question": "Wat is −3 + 7?",
      "options": [
        "4",
        "−4",
        "10",
        "−10"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "negatief_plus_positief",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Strategie: gebruik de getallenlijn. Stap 1: Begin bij −3. Stap 2: Ga 7 stappen naar rechts (optellen). Stap 3: −3 + 7 = 4.",
        "distractorExplanations": {
          "0": "Goed! −3 + 7 = 4. Je begint bij −3 en gaat 7 naar rechts.",
          "1": "Veelgemaakte fout: het minteken behouden. −3 + 7 = 4 (positief), niet −4.",
          "2": "Veelgemaakte fout: de absolute waarden optellen. |−3| + |7| = 10, maar −3 + 7 = 4.",
          "3": "Veelgemaakte fout: beide negatief maken. −3 + (−7) = −10, maar het is −3 + 7 = 4."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-002",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "multiple_choice",
      "question": "Wat is −5 + (−3)?",
      "options": [
        "−8",
        "−2",
        "8",
        "2"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "negatief_plus_negatief",
      "variantIndex": 2,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Strategie: twee negatieve getallen optellen → verder naar links. Stap 1: Begin bij −5. Stap 2: Tel −3 op → ga 3 stappen naar links. Stap 3: −5 + (−3) = −8.",
        "distractorExplanations": {
          "0": "Goed! −5 + (−3) = −8. Twee negatieve getallen optellen geeft een nog negatiever getal.",
          "1": "Veelgemaakte fout: aftrekken. −5 − (−3) = −5 + 3 = −2, maar de vraag is optellen.",
          "2": "Veelgemaakte fout: de mintekens negeren. |−5| + |−3| = 8, maar het antwoord is −8.",
          "3": "Veelgemaakte fout: −5 + 3 = −2 berekenen. Maar het is −5 + (−3), niet −5 + 3."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-003",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "multiple_choice",
      "question": "De temperatuur is −8°C. Het wordt 12 graden warmer. Wat is de nieuwe temperatuur?",
      "options": [
        "4°C",
        "−4°C",
        "20°C",
        "−20°C"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "negatief_plus_context",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Strategie: tel de stijging op bij de begintemperatuur. Stap 1: −8 + 12. Stap 2: Begin bij −8, ga 12 stappen naar rechts. Stap 3: −8 + 12 = 4°C.",
        "distractorExplanations": {
          "0": "Goed! −8 + 12 = 4°C. De temperatuur stijgt boven nul.",
          "1": "Veelgemaakte fout: het minteken behouden. −8 + 12 = 4 (positief), niet −4.",
          "2": "Veelgemaakte fout: de absolute waarden optellen. 8 + 12 = 20, maar −8 + 12 = 4.",
          "3": "Veelgemaakte fout: aftrekken in plaats van optellen. −8 − 12 = −20, maar het wordt warmer (optellen)."
        }
      }
    },
    {
      "id": "GET-NEGATIEF-PLUS-004",
      "familyId": "GET-NEGATIEF-PLUS",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "negatieve_getallen",
      "subSkill": "negatief_optellen",
      "questionType": "multiple_choice",
      "question": "Wat is 6 + (−9)?",
      "options": [
        "−3",
        "3",
        "−15",
        "15"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "positief_plus_negatief",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Strategie: optellen van een negatief getal = aftrekken. Stap 1: 6 + (−9) = 6 − 9. Stap 2: 6 − 9 = −3.",
        "distractorExplanations": {
          "0": "Goed! 6 + (−9) = 6 − 9 = −3.",
          "1": "Veelgemaakte fout: 9 − 6 = 3. Het teken klopt niet: 6 − 9 = −3, niet +3.",
          "2": "Veelgemaakte fout: de absolute waarden optellen met minteken. 6 + 9 = 15, maar het is 6 + (−9) = −3.",
          "3": "Veelgemaakte fout: de absolute waarden optellen. 6 + 9 = 15, maar het is 6 − 9 = −3."
        }
      }
    }
  ]
}
